export const CWR_WELCOME_QUERY_PARAM = 'cwrWelcome';

export type CwrWelcomeVariant = 'personalSpace' | 'sharedSpace' | 'liveDoc';
